export class StringUtils {
  /**
   * Makes the first character in the string uppercase
   * @param str Provided string
   */
  public static capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
